import Swiper, { Navigation, Pagination, A11y } from 'swiper';

export default () => {

  const gridResults = document.querySelector(
    '#results-slider__sidebar'
  );
  const gridResultsAmount = gridResults.dataset.totalResults;

  // results slider
  const resultsSwiper = new Swiper('#results-slider__sidebar', {
    modules: [Navigation , Pagination],
    navigation: {
      nextEl: '.arrow-next-result-sidebar',
      prevEl: '.arrow-prev-result-sidebar',
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
    loop: gridResultsAmount > 1,
    a11y: true,
    keyboardControl: true,
    grabCursor: true,
    watchOverflow: true,
  });
};
